// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProductComplianceSystem-ComplianceAnalysisBypass-ComplianceAnalysisBypassPopupContent-module-textLabel span {
        font-weight: 700;
    }

.ProductComplianceSystem-ComplianceAnalysisBypass-ComplianceAnalysisBypassPopupContent-module-textFieldLabel span {
        font-weight: 700;
    }

.ProductComplianceSystem-ComplianceAnalysisBypass-ComplianceAnalysisBypassPopupContent-module-textFieldLabel .MuiFormControlLabel-asterisk {
        display: inline-block;
        color: #ff0000; 
        padding: 0 2px 0 0;
    }`, "",{"version":3,"sources":["webpack://./src/ProductComplianceSystem/ComplianceAnalysisBypass/ComplianceAnalysisBypassPopupContent.module.css"],"names":[],"mappings":"AACI;QACI,gBAAgB;IACpB;;AAIA;QACI,gBAAgB;IACpB;;AAEA;QACI,qBAAqB;QACrB,cAAc;QACd,kBAAkB;IACtB","sourcesContent":[".textLabel {\n    span {\n        font-weight: 700;\n    } \n}\n\n.textFieldLabel {\n    span {\n        font-weight: 700;\n    }\n\n    :global(.MuiFormControlLabel-asterisk) {\n        display: inline-block;\n        color: #ff0000; \n        padding: 0 2px 0 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textLabel": `ProductComplianceSystem-ComplianceAnalysisBypass-ComplianceAnalysisBypassPopupContent-module-textLabel`,
	"textFieldLabel": `ProductComplianceSystem-ComplianceAnalysisBypass-ComplianceAnalysisBypassPopupContent-module-textFieldLabel`
};
module.exports = ___CSS_LOADER_EXPORT___;
